<div class="groupes">
  @for (groupe of groupes(); track groupe.cle) {
    <details class="groupe" [class]="groupe.classe">
      <summary>
        <span class="material-symbols-outlined famille-icone" aria-hidden="true">{{
          groupe.icone
        }}</span>
        <span class="groupe-contenu">
          <span class="groupe-titre">
            <strong>{{ groupe.libelle }}</strong>
            <span class="total"
              >{{ groupe.cartes.length }} {{ groupe.unite
              }}{{ groupe.cartes.length > 1 ? 's' : '' }}</span
            >
          </span>
          @if (groupe.inconnu) {
            <span class="resume">{{ groupe.cartes[0].etat.libelle }}</span>
          } @else if (groupe.production || groupe.communication) {
            <span class="resume">
              @if (groupe.production) {
                <span class="production-texte"
                  >{{ groupe.production }} en défaut de production</span
                >
              }
              @if (groupe.production && groupe.communication) {
                <span aria-hidden="true"> · </span>
              }
              @if (groupe.communication) {
                <span>{{ groupe.communication }} hors communication</span>
              }
            </span>
          } @else {
            <span class="sr-only">Aucun défaut actif signalé</span>
          }
        </span>
        <span class="compteurs" aria-hidden="true">
          @if (groupe.production) {
            <span class="compteur production-compteur">{{ groupe.production }}</span>
          }
          @if (groupe.communication) {
            <span class="compteur communication-compteur">{{ groupe.communication }}</span>
          }
        </span>
        <span class="material-symbols-outlined chevron" aria-hidden="true">expand_more</span>
      </summary>
      <ul class="groupe-cartes" [attr.aria-label]="groupe.libelle">
        @for (carte of groupe.cartes; track carte.idMateriel) {
          <li app-materiel-carte [carte]="carte"></li>
        }
      </ul>
    </details>
  }
</div>
